<template>

<div>


    <header class="topbar">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/">W3 Website Builder</router-link>
        <ul class="ml-auto navbar-nav" >
          <router-link class="nav-link" href="#" to="/logout">Logout</router-link>
        </ul>
      </nav>
    </header>



  <div class="container">


      <div class="my-3">
        <h1>Edit project</h1> 
      </div>

      <form method="post" @submit.prevent="onSubmit">

      <div class="form-group">
        <label>Name</label>
        <input v-model="project.name" type="text" class="form-control" >
      </div>


<!-- image upload - tiny inline preview -->
<!-- <div class="form-group">
  <label>Imagem</label>
  <div class="d-flex">
    <div class="custom-file">
      <input type="file" class="custom-file-input" @change="onFileChange($event,project,'favicon')">
      <label class="custom-file-label">Upload</label>
    </div>
    <div class="flex-shrink-0">
      <img v-if="project.favicon" :src="project.favicon" class="img-thumbnail" style="max-height:38px">
    </div>
    <button v-if="project.favicon" class="close p-2" @click="project.favicon=''"><span>&times;</span></button>
  </div>
</div> -->



    <button type="submit" class="btn btn-primary">Save</button>
    <router-link class="btn btn-light" :to="'/project/'+project.id">Cancel</router-link>
    <span class="btn btn-danger float-right" @click="onDelete">
      <svg class="icosvg" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
      </svg>
    </span>


</form>
</div>
</div>

</template>
<script>

import componentFunctions from '../mixin.components.js'
import axios from 'axios';
import Vue from 'vue'

import gHeader from '../components/gHeader.vue'
export default {
  name: 'project-form',
  components:{'g-header':gHeader},
  mixins:[componentFunctions],
  props:['id'],
  data() {
    return {
      project:{
        id:'',
          name:'',
          favicon:'',
      },
    }
  },
  methods:{
    getProject(id){
      axios({
        url: '/api/projects/'+id,
      }).then((res) => {
        this.project = res.data;
      });
    },

    onSubmit(){

        var endpoint = '/api/projects';
        if(this.id) endpoint  = endpoint +'/'+this.id

        axios({
            method: 'post',
            url: endpoint,
            data: this.project
        }).then((res) => {

            this.$router.push('/project/'+res.data.id);

      });

    },
    onDelete(){
        if(!confirm("Are you sure?")) return;

        axios({
            method: 'delete',
            url: '/api/projects/'+this.id,
        }).then((res) => {

            this.$router.push('/');

      });

    },



  },
  mounted(){
      this.getProject(this.id);
  }

}



</script>

<style>

</style>
